/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_MissingInputs */

const en_us2_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout is no longer in your plan.`)
};

const pt_br2_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino não está mais no seu plano.`)
};

const es_419_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento ya no está en tu plan.`)
};

const pt_pt2_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino já não está no teu plano.`)
};

const fr_fr2_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance n'est plus dans ton programme.`)
};

const de_de2_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training ist nicht mehr in deinem Plan.`)
};

const it_it2_workout_quick_missing = /** @type {(inputs: Workout_Quick_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento non è più nella tua scheda.`)
};

/**
* | output |
* | --- |
* | "This workout is no longer in your plan." |
*
* @param {Workout_Quick_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_missing = /** @type {((inputs?: Workout_Quick_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_missing(inputs)
	if (locale === "es-419") return es_419_workout_quick_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_missing(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_missing(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_missing(inputs)
	return en_us2_workout_quick_missing(inputs)
});
export { workout_quick_missing as "workout-quick.missing" }